import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waLink, SPECIALIST_MESSAGE } from "../lib/config";

export default function WhatsAppFloat() {
  return (
    <motion.a
      data-testid="whatsapp-float-button"
      href={waLink(SPECIALIST_MESSAGE)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Falar com um especialista no WhatsApp"
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 2.2, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      className="fixed bottom-6 right-6 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-gold/50 animate-pulse-ring" />
      <span className="relative flex w-14 h-14 rounded-full bg-gold items-center justify-center shadow-[0_12px_40px_-8px_rgba(233,184,63,0.7)] group-hover:bg-bone transition-colors duration-300">
        <MessageCircle size={24} className="text-ink" />
      </span>
    </motion.a>
  );
}
